import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function FullBoardIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 -420 512 512' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <g>
                <path
                    transform="scale(1,-1)"
                    d="M463 8v-1c10 -10 10 -27 0 -37s-27 -10 -37 0v1v0l-139 139c-2 2 -13 12 -28 28l-173 -173v0l-1 -1c-10 -10 -27 -10 -37 0s-10 27 0 37l1 1v0l173 173l-222 222l6 6s77 22 281 -178c10 14 18 33 20 58c-2 20 4 40 19 55c1 1 6 4 6 4l109 86l10 -10l-119 -112l13 -13
l115 115l11 -10l-115 -115l11 -11l115 115l9 -10l-114 -114l13 -13l111 117l11 -11l-91 -114l-3 -3c-13 -12 -30 -17 -46 -17v0c-36 0 -61 -19 -78 -38c1 -33 40 -50 47 -52c11 -11 122 -124 122 -124v0z"
                />
            </g>
        </Icon>
    );
}
